/**
 * File-related constants used across the application
 */

/**
 * Allowed file extensions for document uploads
 */
export const ALLOWED_FILE_EXTENSIONS = {
  PDF: 'pdf',
  XLS: 'xls',
  XLSX: 'xlsx',
  CSV: 'csv',
  XML: 'xml',
} as const

/**
 * Array of allowed file extensions (for validation)
 */
export const ALLOWED_FILE_EXTENSIONS_ARRAY: readonly string[] = [
  ALLOWED_FILE_EXTENSIONS.PDF,
  ALLOWED_FILE_EXTENSIONS.XLS,
  ALLOWED_FILE_EXTENSIONS.XLSX,
  ALLOWED_FILE_EXTENSIONS.CSV,
] as const

/**
 * Mutable array of allowed file extensions (for use in props)
 */
export const ALLOWED_FILE_EXTENSIONS_ARRAY_MUTABLE = [
  ALLOWED_FILE_EXTENSIONS.PDF,
  ALLOWED_FILE_EXTENSIONS.XLS,
  ALLOWED_FILE_EXTENSIONS.XLSX,
  ALLOWED_FILE_EXTENSIONS.CSV,
]

/**
 * String format for HTML accept attribute (e.g., ".pdf,.xls,.xlsx,.csv")
 */
export const ALLOWED_FILE_EXTENSIONS_ACCEPT = `.${ALLOWED_FILE_EXTENSIONS.PDF},.${ALLOWED_FILE_EXTENSIONS.XLS},.${ALLOWED_FILE_EXTENSIONS.XLSX},.${ALLOWED_FILE_EXTENSIONS.CSV}`

/**
 * Maximum file size in MB
 */
export const MAX_FILE_SIZE_MB = 2

/**
 * Maximum file size in bytes (2MB)
 */
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024

/**
 * UI messages for file uploads
 */
export const FILE_UPLOAD_MESSAGES = {
  SELECT_FILE_PLACEHOLDER: 'Selecciona un archivo para cargar al Mes de Facturación',
  FILE_REQUIRED: 'Es necesario seleccionar un archivo para continuar',
} as const
